import React, { ReactElement } from 'react';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import CustomersBar from 'src/components/CustomersBar';
import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import { PepXmlRouterWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import Audits from 'src/components/Audits';
import { AuditIdMission } from 'src/components/AuditIdMission/AuditIdMission';

import Header from 'src/components/Header';
import { observer } from 'src/utils/mobx-react';
import { BetTickerV2 } from 'src/domains/sportsbook/trading/view/bet-ticker/BetTickerV2';

export const BetTickerPageV2 = observer('BetTickerPageV2', (): ReactElement => {
    return (
        <LayoutWrapper>
            <MainContainer>
                <Header />
                <div className='flex flex-col p-6 bg-white m-3 rounded-[6px] overflow-y-auto max-h-[calc(100vh-24px)] basis-[calc(100%-88px)]'>
                    <BetTickerV2 />
                </div>
            </MainContainer>
            <CustomersBar />

            <EventsTrigger />
            <Audits />
            <ComplianceAudits />
            <AuditIdMission />
            <PepXmlRouterWrapper />
        </LayoutWrapper>
    );
});
